<template>
  <div class="bigData-container-l clearfix">
    <div class="fl" style='width: 32.0189%'>
      <overallOccupancyRate/>
      <rentRevenueranking style='margin-top: 12px;'/>
      <industrialStructureAnalysis/>
    </div>
    <div class="fr" style='width: 67.0347%;overflow: hidden'>
      <dataSummary/>
      <areaMap/>
      <div style='margin-top: 12px;' class='fix-box-between'>
        <operationDataStatistics/>
        <tenantAbnormalWarning/>
      </div>
    </div>
  </div>
</template>

<script>
  import overallOccupancyRate from "./overallOccupancyRate";
  import rentRevenueranking from "./rentRevenueranking";
  import industrialStructureAnalysis from "./industrialStructureAnalysis";
  import dataSummary from "./dataSummary";
  import areaMap from "./areaMap";
  import operationDataStatistics from "./operationDataStatistics";
  import tenantAbnormalWarning from "./tenantAbnormalWarning";


  export default {
    name: "dataLeft",
    components: {
      overallOccupancyRate,
      rentRevenueranking,
      industrialStructureAnalysis,
      dataSummary,
      areaMap,
      operationDataStatistics,
      tenantAbnormalWarning,

    },
    data() {
      return {}
    },
    methods: {},
    created() {

    },
  }
</script>

<style scoped lang="scss">
  .bigData-container-l {
    width: 67.09%;
    float: left;
  }

  @media screen and (max-width: 1903px) {
    .bigData-container-l {
      width: 100%;
      float: none;
    }
  }


</style>
